import { IMAGE_HOST } from "../../server/config";
import OutputPerson from "../../dtos/person";
import "./styles.css";
import React from "react";

type propsType = {
  person: OutputPerson;
  className?: string;
};

function CardPerson({ person, className = "", ...others }: propsType) {
  return (
    <div
      className={"card-person" + (className === "" ? "" : " " + className)}
      {...others}
    >
      <div className="profile">
        <img src={IMAGE_HOST + person.profile} alt={person.id} />
      </div>
      <div className="text">
        <div className="title">{person.name}</div>
        <div className="label">{person.position}</div>
      </div>
    </div>
  );
}

export default CardPerson;
